import { useTranslation } from 'react-i18next';
import { EmptyState } from '@ui-kit';

export default function AuthRequiredScreen() {
  const { t } = useTranslation('shell');

  return (
    <EmptyState
      className="min-h-screen bg-background"
      title={t('auth.requiredTitle')}
      description={t('auth.requiredBody')}
    />
  );
}
